export default function IF() {
  return (
    <div className="p-4">
      <h1>IF</h1>
    </div>
  );
}
